import { Box, SkeletonTable, SkeletonText } from '@neshane/blueberry';
import React from 'react';

export function OperationsPaginatedTableLoader() {
    return (
        <Box className="flex flex-col gap-16">
            <SkeletonTable
                numberOfRows={5}
                columns={[
                    { header: <SkeletonText width="30%" />, cell: <SkeletonText width="50%" />, width: '220px' },
                    { header: <SkeletonText width="30%" />, cell: <SkeletonText width="30%" />, width: '150px' },
                    { header: <SkeletonText width="30%" />, cell: <SkeletonText width="20%" />, width: '80px' },
                    { header: <SkeletonText width="30%" />, cell: <SkeletonText width="20%" />, width: '80px' },
                    { header: <SkeletonText width="30%" />, cell: <SkeletonText width="30%" />, width: '120px' },
                    { header: <SkeletonText width="30%" />, cell: <SkeletonText width="40%" />, width: '160px' },
                    { header: <SkeletonText width="30%" />, cell: <SkeletonText width="30%" />, width: '120px' },
                ]}
                rowHeight="compact"
                withHeader
                withColumnSeparator
            />
        </Box>
    );
}

export default OperationsPaginatedTableLoader;
